import { useField } from 'formik';
import React from 'react';
import clsx from 'clsx';

interface CheckboxProps {
  label?: string;
  name: string;
  isRequired?: boolean;
  disabled?: boolean;
}

export const FormikCheckbox = ({ children, label, ...props }: React.PropsWithChildren<CheckboxProps>) => {
  const [field, meta] = useField({ ...props, type: 'checkbox' });
  const isError = meta.touched && meta.error;

  return (
    <label
      className={clsx(
        'cursor-pointer select-none',
        isError && 'text-red-500',
        props.disabled ? 'text-gray-20' : 'text-black-default'
      )}
    >
      {label && <p className='block mb-2 text-sm font-bold tracking-wide font-effra'>{label}</p>}
      {props.isRequired && <span className='px-1'>*</span>}
      <input {...field} {...props} type='checkbox' className='max-w-xs mr-2 bg-current rounded-lg' />
      {children}
    </label>
  );
};
